module.exports = __webpack_public_path__ + "static/media/search.3e27f940.svg";